<template>
<v-container fluid fill-height>
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-else>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="primary" class="white--text">
                    <v-toolbar-title>Scouting Score Scales</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon dark large>format_list_numbered</v-icon>
                </v-toolbar>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-alert :value="error != null" outline type="error">
                            {{error}}
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn color="primary" block @click="showEditAddScoutingScoreScale({ IsActive: true })">
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout pt-3>
                    <v-flex xs12>
                        <scouting-score-scale-table :search="search" :filteredItems="filteredItems" @edit="showEditAddScoutingScoreScale($event)"></scouting-score-scale-table>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog 
            :value="editing"
            fullscreen 
            hide-overlay 
            transition="dialog-bottom-transition">
            <scouting-score-scale-edit 
                v-if="editing"
                :item="editItem"                
                :submitLoading="loading"
                :submitError="error"
                :availableCategories="availableCategories"
                @submit="handleSubmit"
                @cancel="cancelEdit()">
            </scouting-score-scale-edit>
        </v-dialog>
</v-container>
</template>

<script>
import ScoutingScoreScaleTable from "@/components/configuration/scoutingScoreScales/ScoutingScoreScaleTable.vue";
import ScoutingScoreScaleEdit from "@/components/configuration/scoutingScoreScales/ScoutingScoreScaleEdit.vue";

import scoutApi from '@/api/scoutApi'
import productCategoryApi from "@/api/productCategoryApi";

export default {
    components: {
        ScoutingScoreScaleTable: ScoutingScoreScaleTable,
        ScoutingScoreScaleEdit: ScoutingScoreScaleEdit
    },
    data() {
        return {
            editing: false,
            error: null,
            loading: false,
            search: "",
            activeOnly: true,
            editItem: null,
            scoutingScoreScales: [],
            availableCategories: []
        }
    },
    computed: {
        filteredItems() {
            return this.scoutingScoreScales.filter(c => c.IsActive === this.activeOnly || !this.activeOnly);
        }
    },
    methods: {
        async loadScoutingScoreScales() {
            this.loading = true;
            this.error = null;

            try {
                this.scoutingScoreScales = await scoutApi.getScoutingScoreScales();

                const productCategories = await productCategoryApi.getProductCategories();

                this.availableCategories = productCategories.map(x => {
                    return {
                        ProductCategoryID: x.ID,
                        ProductCategoryName: x.Name
                    };
                });

            } catch (err) {
                this.error = err;
            }

            this.loading = false;
        },
        showEditAddScoutingScoreScale(item) {            
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.error = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            this.loading = true;

            try {
                let response = {};

                if (item.ScoutingScoreScaleID > 0) {
                    response = await scoutApi.updateScoutingScoreScale(item);                    
                } else {                    
                    response = await scoutApi.addScoutingScoreScale(item);                    
                }                

                if (!response.Success) {
                    this.error = response.ErrorMessages.join(', ');
                    return;
                }

                this.editing = false;
            } catch (err) {
                this.error = err;
                return;

            } finally {
                this.loading = false;
            }

            await this.loadScoutingScoreScales();
        }
    },
    async created() {
        await this.loadScoutingScoreScales();
    }
}
</script>
